/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */
import * as axios from "axios";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createRouter, createWebHashHistory } from "vue-router";

// Plugins
import { registerPlugins } from "@/plugins";

// Components
import App from "./App.vue";
import HomePage from "./pages/index.vue";
import RepoPage from "./pages/RepoPage.vue";

// Composables
import { createApp } from "vue";

// Styles
import "unfonts.css";

import { currentAuthorizationToken } from "./authenticationTokens";

const routes = [
  { name: "home", path: "/", component: HomePage },
  { name: "repo", path: "/repos/:repo/", component: RepoPage, props: true },
];

axios.default.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const a = currentAuthorizationToken.value;
    console.log("axios default", a?.server, config.url);
    if (a && config.url?.startsWith("/repos/")) {
      config.baseURL = a.server + "/api/v1/";
      config.headers.Authorization = `token ${a.token}`;
    }
  }
  return config;
});

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
});

const app = createApp(App).use(router).use(VueQueryPlugin);
registerPlugins(app);

app.mount("#app");
